// src/components/InstallApp.js

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Text,
  Heading,
  Image,
  VStack,
  HStack,
} from "@chakra-ui/react";

function InstallApp() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  // Device detection
  const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;

  useEffect(() => {
    if (!isMobile) return;

    // Already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      return;
    }

    // Don't show again if user dismissed it
    if (localStorage.getItem("hideInstallPopup") === "true") {
      return;
    }

    let timer;

    if (isAndroid) {
      const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);

        timer = setTimeout(() => {
          setShowPopup(true);
        }, 10000);
      };

      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

      return () => {
        clearTimeout(timer);
        window.removeEventListener(
          "beforeinstallprompt",
          handleBeforeInstallPrompt,
        );
      };
    }

    if (isIOS) {
      timer = setTimeout(() => {
        setShowPopup(true);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [isAndroid, isIOS, isMobile]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;

    console.log("Install outcome:", outcome);

    if (outcome === "accepted") {
      localStorage.setItem("hideInstallPopup", "true");
    }

    setShowPopup(false);
    setDeferredPrompt(null);
  };

  const handleLater = () => {
    localStorage.setItem("hideInstallPopup", "true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <Box
      position="fixed"
      left="16px"
      right="16px"
      bottom="20px"
      bg="white"
      borderRadius="20px"
      boxShadow="2xl"
      border="1px solid"
      borderColor="orange.100"
      p={5}
      zIndex={9999}
    >
      <VStack spacing={4}>
        <Image
          src="/logo192.png"
          boxSize="64px"
          borderRadius="16px"
          alt="Sivalayam"
        />

        <Heading size="md" textAlign="center">
          🕉️ Sivalayam Thokada
        </Heading>

        {isAndroid ? (
          <>
            <Text textAlign="center">
              Install our app for faster access, temple updates and a better
              experience.
            </Text>

            <HStack width="100%">
              <Button flex={1} variant="outline" onClick={handleLater}>
                Later
              </Button>

              <Button flex={1} colorScheme="orange" onClick={handleInstall}>
                Install
              </Button>
            </HStack>
          </>
        ) : (
          <>
            <Text textAlign="center">
              To install this app on your iPhone:
              <br />
              <strong>Tap Share → Add to Home Screen</strong>
            </Text>

            <Button width="100%" colorScheme="orange" onClick={handleLater}>
              Got it
            </Button>
          </>
        )}
      </VStack>
    </Box>
  );
}

export default InstallApp;
